import { render, staticRenderFns } from "./ModalCreate.vue?vue&type=template&id=2d050e6e&scoped=true&"
import script from "./ModalCreate.vue?vue&type=script&lang=js&"
export * from "./ModalCreate.vue?vue&type=script&lang=js&"
import style0 from "./ModalCreate.vue?vue&type=style&index=0&id=2d050e6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d050e6e",
  null
  
)

export default component.exports